/**
 * Standard Actions configuration for the amphr theme.
 *
 * Storefront Renderer injects the Shopify Standard Actions bundle
 * (`window.Shopify.actions.{updateCart,openCart,getCart,…}`). This file
 * points those actions at the amphr cart system (snippets/cart-drawer.liquid
 * + amphr-cart.js) so cart mutations coming from Shop app embeds, storefront
 * web components, or apps keep the drawer and header badge in sync.
 * Remove this file and the bundle's built-in defaults take over
 * (navigate to /cart on openCart; no in-theme refresh on updateCart).
 */

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return false;

  actions.openCart.configure({
    async handler(defaultHandler) {
      if (window.amphr && typeof window.amphr.openDrawer === 'function' && document.getElementById('amphr-cart')) {
        window.amphr.openDrawer('#amphr-cart');
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    // The bundle requires an eventTarget; document is the conventional root.
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try {
        if (window.amphrCart && typeof window.amphrCart.refresh === 'function') {
          await window.amphrCart.refresh();
        }
      } catch (error) {
        console.error('[amphr] Standard Actions cart refresh failed; reloading.', error);
        window.location.reload();
      }
      return result;
    },
  });

  return true;
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, then poll briefly —
// the bundle may attach asynchronously after DOMContentLoaded.
if (!initStandardActions()) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (initStandardActions()) return;
      let attempts = 0;
      const timer = setInterval(() => {
        if (initStandardActions() || ++attempts >= 20) clearInterval(timer);
      }, 250);
    },
    { once: true }
  );
}
